/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateCatalogModifierGroupRequestModifiersInner } from './UpdateCatalogModifierGroupRequestModifiersInner';
import {
    UpdateCatalogModifierGroupRequestModifiersInnerFromJSON,
    UpdateCatalogModifierGroupRequestModifiersInnerFromJSONTyped,
    UpdateCatalogModifierGroupRequestModifiersInnerToJSON,
    UpdateCatalogModifierGroupRequestModifiersInnerToJSONTyped,
} from './UpdateCatalogModifierGroupRequestModifiersInner';

/**
 * 
 * @export
 * @interface UpdateCatalogModifierGroupRequest
 */
export interface UpdateCatalogModifierGroupRequest {
    /**
     * 
     * @type {Array<UpdateCatalogModifierGroupRequestModifiersInner>}
     * @memberof UpdateCatalogModifierGroupRequest
     */
    modifiers: Array<UpdateCatalogModifierGroupRequestModifiersInner>;
}

/**
 * Check if a given object implements the UpdateCatalogModifierGroupRequest interface.
 */
export function instanceOfUpdateCatalogModifierGroupRequest(value: object): value is UpdateCatalogModifierGroupRequest {
    if (!('modifiers' in value) || value['modifiers'] === undefined) return false;
    return true;
}

export function UpdateCatalogModifierGroupRequestFromJSON(json: any): UpdateCatalogModifierGroupRequest {
    return UpdateCatalogModifierGroupRequestFromJSONTyped(json, false);
}

export function UpdateCatalogModifierGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCatalogModifierGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'modifiers': ((json['modifiers'] as Array<any>).map(UpdateCatalogModifierGroupRequestModifiersInnerFromJSON)),
    };
}

export function UpdateCatalogModifierGroupRequestToJSON(json: any): UpdateCatalogModifierGroupRequest {
    return UpdateCatalogModifierGroupRequestToJSONTyped(json, false);
}

export function UpdateCatalogModifierGroupRequestToJSONTyped(value?: UpdateCatalogModifierGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modifiers': ((value['modifiers'] as Array<any>).map(UpdateCatalogModifierGroupRequestModifiersInnerToJSON)),
    };
}

